import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay/legacy';
import { FormattedMessage } from 'dibs-react-intl';
import contactDealerLauncher from 'dibs-buyer-layout/exports/contactDealerLauncher';

function StorefrontContactButton(props) {
    return (
        <div
            className={props.className}
            data-tn="storefront-head-contact-button"
            onClick={() => {
                const { seller, isPreview } = props;
                const sellerId = seller ? seller.serviceId : null;
                if (!isPreview && sellerId) {
                    contactDealerLauncher({
                        sellerId,
                        launchOrigin: 'in dealer storefront - button',
                    });
                }
            }}
        >
            <FormattedMessage id="StorefrontContactButton.cta" defaultMessage="Message" />
        </div>
    );
}

StorefrontContactButton.propTypes = {
    className: PropTypes.string,
    isPreview: PropTypes.bool.isRequired,
    seller: PropTypes.object.isRequired,
};

export default createFragmentContainer(StorefrontContactButton, {
    seller: graphql`
        fragment StorefrontContactButton_seller on Seller {
            serviceId
        }
    `,
});
